export const environment = {
  logoutUrl: 'https://open.psm.church/',
  keycloak: {
    url: 'https://auth.psm.church/auth',
    realm: 'open-church',
    clientId: 'open-church-frontend'
  },
  features: {
    errorInterception: true
  }
}
